import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { IGuide } from "../../../employment101/guide/models/guide";
import { CommonService } from "../../services/common.service";
import { CareerPlanService } from "./services/careerplan.service";

import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { IdentityService } from "../../../employment101/services/identity.service";



@Component({
  selector: 'careerplan-activity-select',
  templateUrl: './careerplan-activity-select.component.html',
  providers: [CareerPlanService, IdentityService]
})
export class CareerPlanActivitySelectComponent {

  @Input()
  guide: IGuide;

  @Input()
  activityId: number;

  @Input()
  task: string = '';

  @Input()
  completed: boolean = false;

  @Input()
  currentPath: string = '';

  @Input()
  addGoal: boolean = false;

  @Input()
  addSelfEvaluation: boolean = false;

  @Output()
  continue: EventEmitter<any> = new EventEmitter();

  goalId: number;
  stepId: number;

  caseManager: boolean = false;

  syncPlan: boolean = false;


  base: string;

  careerPlanUrl: string = '';
  careerPlanActivityUrl: string = '';
  syncCareerPlanUrl: string = '';
  careerPlanGoalsUrl: string = '';
  selfEvaluationUrl: string = '';
  returnUrl: string = '';

  modalRef: BsModalRef;

  constructor(private careerPlanService: CareerPlanService, private commonService: CommonService,
    private router: Router, private modalService: BsModalService, private identitySrv: IdentityService) { }

  ngOnInit() {
    this.load();
  }

  load() {

    this.commonService.baseSite().subscribe(baseUrl => {

      //console.log('BaseUrl', baseUrl);

      this.base = _.trimEnd(baseUrl, '/');
      this.returnUrl = this.base + this.currentPath + `/true`;

    });

    this.identitySrv.getCaseManagerInfo().subscribe(resp => {

      //console.log('Case Manager Info', resp);

      if (resp != null && resp.workingAsCaseManager == true) {
        this.caseManager = true;
      } else {
        this.caseManager = false;
      }
    });


    this.careerPlanService.getCareerPlanActivityUrl()
      .subscribe(res => {

        this.careerPlanActivityUrl = res;

        //console.log('Career Plan Activity URL', res);

      });

    this.careerPlanService.getSyncCareerPlanUrl()
      .subscribe(res => {

        this.syncCareerPlanUrl = res;

        //console.log('Sync Career Plan URL', res);

      });

    this.careerPlanService.getCareerPlanGoalsUrl()
      .subscribe(res => {

        this.careerPlanGoalsUrl = res;

        //console.log('Career Plan Goals URL', res);

      });

    this.careerPlanService.getSelfEvaluationUrl()
      .subscribe(res => {

        this.selfEvaluationUrl = res;

        //this.selfEvaluationUrl = this.selfEvaluationUrl.replace("&amp;", "&");
        this.selfEvaluationUrl = this.selfEvaluationUrl.replace("amp;", "");

      });

    if (!this.addGoal && !this.addSelfEvaluation) {

      this.careerPlanService.getActivityDetails(this.guide.careerPlanId, this.activityId).subscribe(res => {

        //console.log("Activity Details", res);

        if (res == null) {
          //need to sync
          this.syncPlan = true;          
          this.returnUrl = this.base + this.currentPath

        } else {
          this.activityId = res.activityId;
          this.goalId = res.goalId;
        }      
      });
    }
    
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  reload() {
    window.location.reload();
  }

}
